import React from 'react';
import { useIntl } from 'react-intl';
import { Evidence } from '@eas/common-web';
import { useSprFiles } from '../spr-files';
import { useColumns } from './spr-file-all-columns';

export const SPR_FILES_ALL_IDENTIFIER = 'SPR_FILES_ALL';
export const SPR_FILES_ALL_VERSION = 4;

export function SprFilesAll() {
  const intl = useIntl();
  const columns = useColumns();

  const { evidenceBag } = useSprFiles({
    evidenceProps: {
      identifier: SPR_FILES_ALL_IDENTIFIER,
      version: SPR_FILES_ALL_VERSION,
      tableProps: {
        columns,
        tableName: intl.formatMessage({
          id: 'ES__SPR_FILES__ALL__TABLE__TITLE',
          defaultMessage: 'SPR spisy',
        }),
      },
      detailProps: {
        toolbarProps: {
          showBtn: (btn) => !['NEW'].includes(btn),
        },
      },
    },
  });

  return <Evidence {...evidenceBag} />;
}
